import { GetExtractsNewUsecase } from "./../../../../core/usecases/extract/get-extract-new.usecase";
import {
  BlockedBalanceEnum,
  DetailsTransacionEnum,
  FibraFacilEnum,
} from "@src/shared/enum/bfd-popover.enum";
import { PopoverService } from "./../../../../shared/services/popover.service";
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  OnInit,
  ViewChild,
} from "@angular/core";
import { ExtractRequestNew } from "@src/core/domain/extract/extract.model";
import jwt_decode from "jwt-decode";
import * as moment from "moment";
import { GetBalanceNewUsecase } from "@src/core/usecases/extract/get-balance-new.usecase";
import * as Util from "@src/shared/util-common";

export interface ClientIdInterface {
  id: number;
  nome: string;
  numero: number;
  numeroDocumento: string;
  tipoDocumento: string;
  isMaster: boolean;
}
@Component({
  selector: "bfd-extract-general-view",
  templateUrl: "./bfd-extract-general-view.component.html",
  styleUrls: ["./bfd-extract-general-view.component.scss"],
})
export class ExtractGeneralViewComponent implements OnInit, AfterViewInit {
  @ViewChild("anchor", { static: false }) anchor: ElementRef<HTMLElement>;
  observer: IntersectionObserver;

  selectedRange = {
    start: new Date(),
    end: new Date(),
  };

  public balanceObj = [];

  public accountBalance = {
    titleBalance: "Saldos",
    button: '',
    listBalance: [],
  };

  public fibraFacilBalance = {
    titleBalance: "Limite Fibra Fácil",
    button: '',
    listBalance: [
  //     {
  //   description: 'Total',
  //   value: 'R$ 5.000.000,00'
  // },{
  //   description: 'Utilizado',
  //   value: 'R$ 0,00'
  // },{
  //   description: 'Disponível',
  //   value: 'R$ 5.000.000,00'
  // }
],
  };

  public movements = {
    titleBalance: "Movimentações previstas",
    listBalance: [
      //   {
      //   iconColor: 'success',
      //   icon: 'wallet',
      //   description: 'Entradas',
      //   value: 'R$ 50.000,00',
      // },
      // {
      //   iconColor: 'danger',
      //   icon: 'wallet',
      //   description: 'Saídas',
      //   value: 'R$ 21.000,00',
      // },
      // {
      //   iconColor: 'alert',
      //   icon: 'wallet',
      //   description: 'Saldo previsto',
      //   value: 'R$ 21.000,00',
      // },
    ],
  };

  public menu = ["Todas", "Entradas", "Saídas"];
  public balanceSingle = [];
  public typeView!: string;
  public showError = false;
  loadDataGrid = false;
  noDataShow = false;

  public contentEmptyData = {
    icon: "bfd-pict-alert",
    title: "Não há movimentações",
    description: "Tente efetuar uma nova pesquisa informando um outro período",
  };

  public view: string = "view-1";
  public mainPrefix = "view";
  public numberAccount!: number;
  public companyDefaultId!: string;
  public clientId!: ClientIdInterface;
  public loadingControler = false;
  public loading = false;
  public loadingScroll = false;
  public payloadGet: ExtractRequestNew = {
    accountNumber: "",
    clientId: 0,
    dataInicio: "",
    dataFinal: "",
    numeroPagina: "",
    tipo: "",
    quantidadeRegistrosPagina: "",
  };
  public pagina = "0";
  public qtfRegister = "30";
  public toDay = moment().format("YYYY-MM-DD");

  constructor(
    public popoverService: PopoverService,
    private getExtractsNewUsecase: GetExtractsNewUsecase,
    private getBalanceNew: GetBalanceNewUsecase
  ) {}
  ngOnInit(): void {
    this.loading = true;
  }

  ngAfterViewInit(): void {
    this.loadingPayload();
  }

  async loadingPayload(): Promise<void> {
    try {
      await this.getParamsDefaultCompanyClientId();
      await this.findClientId();
      this.payloadGet = {
        accountNumber: await this.waitForSessionStorageKey("account_selected"),
        clientId: this.clientId.id,
        dataInicio: this.getDateNDaysAgo(7),
        dataFinal: this.toDay,
        numeroPagina: this.pagina,
        tipo: "",
        quantidadeRegistrosPagina: this.qtfRegister,
      };
      this.getExtract(this.payloadGet);
      this.getBalance(this.payloadGet);
    } catch (e) {
      this.loading = false;
      console.error(e.message);
    }
    this.infinityScroll();
  }

  async waitForSessionStorageKey(
    key: string,
    timeout = 10000
  ): Promise<string> {
    const interval = 100;
    let waited = 0;

    return new Promise((resolve, reject) => {
      const check = () => {
        const value = sessionStorage.getItem(key);
        if (value !== null) {
          resolve(value);
        } else if (waited >= timeout) {
          reject(
            new Error(`Timeout esperando chave "${key}" no sessionStorage`)
          );
        } else {
          waited += interval;
          setTimeout(check, interval);
        }
      };
      check();
    });
  }

  private getExtract(payload: ExtractRequestNew) {
    this.loadingControler ? (this.loadingScroll = true) : (this.loading = true);
    this.getExtractsNewUsecase
      .execute(payload)
      .subscribe(
        this.successListExtractResponse,
        this.errorListExtractResponse
      );
  }

  private successListExtractResponse = (value) => {
    const newData = value.data;

    if (!this.balanceObj || this.balanceObj.length === 0) {
      this.balanceObj = newData;
    } else if (
      newData.length > 0 &&
      this.balanceObj[this.balanceObj.length - 1].data === newData[0].data
    ) {
      const lastItem = this.balanceObj[this.balanceObj.length - 1];
      const mergedItem = {
        ...lastItem,
        lancamentos: [...lastItem.lancamentos, ...newData[0].lancamentos],
      };

      this.balanceObj = [
        ...this.balanceObj.slice(0, -1),
        mergedItem,
        ...newData.slice(1),
      ];
    } else {
      this.balanceObj = [...this.balanceObj, ...newData];
    }

    this.loading = false;
    this.loadingControler = false;
    this.loadingScroll = false;

    Util.registerDataForDownloadFile(this.payloadGet);
  };

  private errorListExtractResponse = (err) => {
    this.loading = false;
    this.showError = true;
    this.loadingControler = false;
    this.loadingScroll = false;
  };

  public getBalance(payload: ExtractRequestNew): void {
    this.getBalanceNew
      .execute(payload)
      .subscribe(this.successBalanceResponse, this.errorBalanceResponse);
  }

  private successBalanceResponse = (value) => {
    if (Number(value.data.valorBloq) === 0) {
      this.accountBalance.listBalance.push({
        description: "Disponível",
        value: value.data.saldoDisp,
      });
      return;
    }

    if (Number(value.data.valorBloq) !== 0) {
      this.accountBalance.button = 'Saiba mais';
      this.accountBalance.listBalance.push(
        {
          description: "Total em conta",
          value: value.data.saldoTotal,
        },
        {
          description: "Disponível",
          value: value.data.saldoDisp,
        },
        {
          description: "Bloqueado",
          value: value.data.valorBloq,
        }
      );
    }
    this.loading = false;
  };

  private errorBalanceResponse = (err) => {
    this.showError = true;
    this.loading = false;
    this.loadingScroll = false;
    this.loadingControler = false;
  };

  public changePage(page): void {
    if (page === "view-1") {
      this.payloadGet.tipo = null;
      this.balanceObj = [];
    }

    if (page === "view-2") {
      this.payloadGet.tipo = "C";
      this.balanceObj = [];
    }

    if (page === "view-3") {
      this.payloadGet.tipo = "D";
      this.balanceObj = [];
    }
    this.getExtract(this.payloadGet);
  }

  public getInfBalance(event, type): void {
    this.balanceSingle = event;
    this.typeView = DetailsTransacionEnum.TypeView;
    this.showPopover();
  }

  public getInfPopover(event?, origin?: string): void {
    switch (origin) {
      case BlockedBalanceEnum.TypeView:
        this.typeView = BlockedBalanceEnum.TypeView;
        this.showPopover();
        break;
      case FibraFacilEnum.TypeView:    
        this.typeView = FibraFacilEnum.TypeView;
        this.showPopover();
        break;
      case DetailsTransacionEnum.TypeView: 
        this.balanceSingle = event;   
        this.typeView = DetailsTransacionEnum.TypeView;
        this.showPopover();
        break;
    }
  }

  public showPopover(): void {
    this.popoverService.setAllowLoad(true);
    this.popoverService.openModal();
  }

  public handleRange(range: { start: Date; end: Date }): void {
    this.payloadGet.dataInicio = moment(range.start).format("YYYY-MM-DD");
    this.payloadGet.dataFinal = moment(range.end).format("YYYY-MM-DD");

    this.getExtract(this.payloadGet);
  }

  async findClientId(): Promise<void> {
    const tokenDecoded: any = await this.decoded(
      sessionStorage.getItem("sessionToken")
    );
    const clients = JSON.parse(tokenDecoded);
    this.clientId = clients.clientes.find(
      (e) => e.numero === this.companyDefaultId
    );
  }

  async getParamsDefaultCompanyClientId(): Promise<void> {
    const defaultCompany = await JSON.parse(
      sessionStorage.getItem("defaultCompany")
    );
    this.companyDefaultId = defaultCompany[0].value;
  }

  private decoded(token) {
    const decoded = jwt_decode(token);
    return decoded;
  }

  getDateNDaysAgo(days: number): string {
    const d = new Date();
    d.setDate(d.getDate() - days + 1);
    return moment(d).format("YYYY-MM-DD");
  }

  public tryRequest(event?): void {
    this.loadingControler = false;
    this.loadingPayload();
    this.getBalance(this.payloadGet);
  }

  public infinityScroll() {
    this.observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          this.loadMoreData();
        }
      },
      {
        root: null,
        threshold: 0.5,
      }
    );

    if (this.anchor && this.anchor.nativeElement) {
      this.observer.observe(this.anchor.nativeElement);
    }
  }

  public loadMoreData(): void {
    this.loadingControler = true;
    console.log(this.loadingControler);
    this.getExtract(this.payloadGet);
  }
}
